import React, { Component } from "react";

import "./projectStyle.scss";
import * as projects from "../../../shared/constants/projects";
import moment from "moment";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { history } from "../../../shared/history/history";
import { openAnotherTab } from "../../../shared/utils/redirectUtils";

class Project extends Component {
  state = {};

  handlePlural(number, string) {
    return `${number} ${number >= 2 ? string + "s" : string}`;
  }

  calculateExperience(projectStartDate) {
    const { experienceDateStartJs } = projects;
    const dateFromat = "DD-MM-YYYY";

    const startTimestamp = moment(projectStartDate, dateFromat);
    const endTimestamp = moment(experienceDateStartJs, dateFromat);
    const duration = moment.duration(startTimestamp.diff(endTimestamp));
    const durationInMonths = duration.asMonths();

    if (durationInMonths < 1) {
      const days = Math.round(duration.asDays());
      return this.handlePlural(days, "day");
    } else if (durationInMonths > 12) {
      const years = Math.round(duration.asYears());
      return this.handlePlural(years, "year");
    } else {
      const months = Math.round(durationInMonths);
      return this.handlePlural(months, "month");
    }
  }
  render() {
    const {
      skillsImages,
      title,
      description,
      appLink,
      githubLink,
      dateProjectStarted,
    } = this.props;

    return (
      <div className="project__wrapper">
        <div
          className="project__title--wrapper"
          onClick={() => openAnotherTab(history, appLink)}
        >
          <div>
            <span className="project__title">{title}</span>
            <img
              className="project__icon"
              src={require("../../../public/static/next.svg")}
              alt="Next icon"
            />
          </div>
          <span className="project__experience">
            <OverlayTrigger
              placement={"bottom"}
              overlay={
                <Tooltip>
                  {
                    "The amount of experience that I had when this project started."
                  }
                </Tooltip>
              }
            >
              <div>
                experience: {this.calculateExperience(dateProjectStarted)}
              </div>
              {/* <img
                      className="project__icon"
                      src={require(`../../../public/static/${iconObj.icon}.${iconObj.iconType}`)}
                      alt={iconObj.icon}
                    /> */}
            </OverlayTrigger>
          </span>
        </div>
        <div className="project__description">{description}</div>
        <div className="project__bottom">
          <div className="project__icon-wrapper">
            {(skillsImages || []).map(
              (iconObj, index) =>
                iconObj && (
                  <OverlayTrigger
                    placement={"bottom"}
                    overlay={<Tooltip>{iconObj.name}</Tooltip>}
                  >
                    <img
                      className="project__icon"
                      src={require(`../../../public/static/${iconObj.icon}.${iconObj.iconType}`)}
                      alt={iconObj.icon}
                    />
                  </OverlayTrigger>
                )
            )}
          </div>
          <div className="project__github__button--wrapper">
            {!!githubLink && (
              <Button
                className="project__github__button"
                onClick={() => openAnotherTab(history, githubLink)}
              >
                Github
                <img
                  alt="button icon"
                  className="project__github__button--icon"
                  src={require("../../../public/static/next.svg")}
                />
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Project;
